<template>
	<div class="design-container">
		<div class="design">

			<div class="tab-list">
				<div
						class="tab-item"
						:class="{'active': cur === item.key }"
						v-for="(item,index) in tabs"
						:key="'tab-'+item.key"
						@click="changeNav(item.key)"
				>
					{{item.title}}
				</div>
			</div>


			<div class="style-box" v-show="cur === 'Part'">
				<Part :key="'panel-part-'+category.id" />
			</div>
			<div class="style-box" v-show="cur === 'Deep'">
				<Deep :key="'panel-deep-'+category.id" />
			</div>
			<div class="style-box" v-show="cur === 'Fabric'">
				<Fabric :key="'panel-fabric-'+category.id" />
			</div>
			<div class="style-box" v-show="cur === 'Custom'" v-if="category.is_enable_embroider && fabric_list.color.tech > 0">
				<Custom :key="'panel-style-'+category.id" />
			</div>

			<div class="btn-submit" @click="next">下一步</div>

			<div class="right2">
				<Summary ></Summary>
			</div>
		</div>
	</div>

</template>

<script>
	import C from '@/utils/constant'
	import {mapState} from 'vuex'
	import Fabric from "./components/Fabric";
	import Part from "./components/Part";
	import Deep from "./components/Deep";
	import Custom from "./components/Custom";
	import GlbRenderer3D from "./components/GlbRenderer3D.vue";
	import Confirm from "./components/Confirm";
	import Summary from "./components/Summary";
	export default {
		name: "Design",
		components: {
			Part,
			Deep,
			Fabric,
			Custom,
			GlbRenderer3D,
			Confirm,
			Summary
		},
		data() {
			return {
				cur: '',
			}
		},
		computed: {
			...mapState({
				category: (state) => state.mtm.picked_category,
				model3d_list: (state) => state.mtm.form_data.model3d_list,
				fabric_list: (state) => state.mtm.form_data.fabric_list,
				form_data: (state) => state.mtm.form_data,
				style_data: (state) => state.mtm.form_data.customize_data,
				figure_page() {
					if(this.$route.params.is_group) {
						return 'GroupFigure'
					} else {
						return 'Figure'
					}
				},
			}),
			tabs() {
				if (this.form_data.mtm_type == 2) {
					return [{
						title: "面料",
						key: 'Fabric',
						img: require("../../assets/images/design/fabric.png"),
						activeImg: require("../../assets/images/design/fabric-active.png"),
					},
						{
							title: "个性",
							key: 'Custom',
							img: require("../../assets/images/design/personality.png"),
							activeImg: require("../../assets/images/design/personality-active.png"),
						},
					]
				} else {
					return [
						{
							title: "面料",
							key: 'Fabric',
							img: require("../../assets/images/design/fabric.png"),
							activeImg: require("../../assets/images/design/fabric-active.png"),
						},
						{
							title: "款式设计",
							key: 'Part',
							img: require("../../assets/images/design/design.png"),
							activeImg: require("../../assets/images/design/design-active.png"),
						},
						{
							title: "深度设计",
							key: 'Deep',
							img: require("../../assets/images/design/design.png"),
							activeImg: require("../../assets/images/design/design-active.png"),
						},
						{
							title: "个性",
							key: 'Custom',
							img: require("../../assets/images/design/personality.png"),
							activeImg: require("../../assets/images/design/personality-active.png"),
						},
					]
				}

			}
		},
		created() {
			// 缓存款式数据
			localStorage.setItem('category', JSON.stringify(this.category))
		},
		mounted() {
			this.cur = 'Fabric'
			this.$emit("showLogin", false);
			this.$emit("showBack", true);
			this.$emit("showNav", false);
			this.$emit("showFooter", false);
		},
		methods: {
			next() {
				console.log(this.tabs)
				let index = this.tabs.findIndex((v=>v.key===this.cur))
				if(index === this.tabs.length - 1) {
					this.go2figure()
				} else {
					this.cur = this.tabs[index+1].key
				}
			},
			go2figure() {
				if(this.form_data.mtm_type == C.MTM_TYPE_SIZE) {
					this.$router.push({name: 'Checkout'})
					return
				}
				if(this.category.customize_data.length) {
					for(let i in this.style_data)  {
						if(!this.style_data[i].print_type) {
							this.$Message.error(`${this.style_data[i].name}制作方式未完善`)
							return
						}
						if(this.style_data[i].type == 2 && !this.style_data[i].image_value) {
							this.$Message.error(`${this.style_data[i].name}定制数据未完善`)
							return
						}
						if(this.style_data[i].type == 1 && (!this.style_data[i].text_value || !this.style_data[i].text_font  || !this.style_data[i].text_color )) {
							this.$Message.error(`${this.style_data[i].name}定制数据未完善`)
							return
						}
					}
				}
				this.$router.push({
					name: this.figure_page
				})
			},
			changeNav(cur) {
				this.cur = cur;
			},
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			// 可以访问组件实例 `this`
			this.$Spin.hide();
			next()
		}
	};
</script>

<style lang="scss" scoped>

	.design-container {
		/*scrollbar-color: #c8d2e0 #f3f4f9;*/
		// 滚动条宽度有三种：thin、auto、none
		/*scrollbar-width: thin;*/
		position: absolute;
		top: 80px;
		left: 0;
		right: 0;
		bottom: 0;
		background: #f3f4f5;
		.design {
			position: absolute;
			width: 1400px;
			top: 20px;
			left: 260px;
			right: 260px;
			bottom: 60px;
			background: #FFF;
			border-radius: 10px;
			display: flex;
			justify-content: center;
			align-items: center;

			.btn-submit {
				position: absolute;
				top: 7px;
				right: 20px;
				width: 120px;
				height: 44px;
				line-height: 44px;
				text-align: center;
				background: #0F114A;
				border-radius: 2px;
				color: #EDD4AC;
				font-size: 16px;
				cursor: pointer;
			}

			.tab-list {
				position: absolute;
				top: 20px;
				left: 20px;
				display: flex;
				z-index: 99;
				.tab-item {
					width: 110px;
					height: 40px;
					line-height: 40px;
					color: #666;
					font-size: 12px;
					margin:0 2px;
					background: #F4F4F4;
					border-radius: 10px 10px 0 0;
					text-align: center;
					cursor: pointer;
					&:first-child {
						margin-left: 0;
					}
					&.active {
						height: 42px;
						line-height: 42px;
						color: #0F114A;
						font-size: 14px;
						font-weight: bold;
						border: 1px solid #0F114A;
						border-bottom: 1px solid white;
						background: white;
					}
				}
			}


			.style-box {
				position: absolute;
				top: 60px;
				left: 20px;
				width: 1360px;
				bottom: 20px;
				z-index: 90;
				background: #FFFFFF;
				border-radius: 0px 10px 10px 10px;
				border: 1px solid #0F114A;

			}


			.ivu-icon {
				line-height: 1.7;
			}


			.ivu-icon {
				line-height: 1.7;
			}

			.tools-panel {
				position: absolute;
				top: 20px;
				right: 320px;
				width: 60px;
				.btn-wrap{
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
					width: 60px;
					margin-bottom: 20px;
					cursor: pointer;
					.btn-tools {
						width: 48px;
						height: 48px;
					}
					.text {
						margin-top: 5px;
						color: #333333;
						font-size: 13px;
					}
				}

			}

			.right2 {
				width: 240px;
				background: #ffffff;
				position: absolute;
				top: 0;
				right: -250px;
			}

		}
	}
</style>
